import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import history from 'app/routes/history';
import _ from 'lodash';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  fixtureMatchImportSchema,
  fixtureMatchImportListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import {
  sagaActions,
  updateFixtureMatchImport,
} from 'app/ducks/fixtureMatchImports/actions';
import { FixtureMatchImportsActionTypes as types } from 'app/ducks/fixtureMatchImports/types';

function* createFixtureMatchImportSaga(action): any {
  yield put(sagaActions.createFixtureMatchImportPending(action.payload.data));
  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).fixtureMatchImports.create(action.payload.data);

  if (response) {
    const normalizedResponse = normalize(response, fixtureMatchImportSchema);
    // const payload = {
    //   id: response.data.id,
    //   status: 'processing',
    // };
    // yield put(updateFixtureMatchImport(payload));

    // history.push(
    //   `/connections/${action.payload.staticData.connectionId}/runs/${response.data.id}`,
    // );
    if (action.payload?.redirect !== undefined) {
      action.payload.redirect(response.data?.id);
    }
    yield put(sagaActions.createFixtureMatchImportSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createFixtureMatchImportFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateFixtureMatchImportSaga(action): any {
  yield put(sagaActions.updateFixtureMatchImportPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).paymentDataImports.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, fixtureMatchImportSchema);

    yield put(sagaActions.updateFixtureMatchImportSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateFixtureMatchImportFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getFixtureMatchImportSaga(action): any {
  yield put(sagaActions.getFixtureMatchImportPending());
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).paymentDataImports.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, fixtureMatchImportSchema);
    yield put(sagaActions.getFixtureMatchImportSuccess(normalizedResponse));
    return normalizedResponse.entities.fixtureMatchImports[
      normalizedResponse.result
    ];
  }
  yield put(
    handleError(
      error,
      sagaActions.getFixtureMatchImportFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllFixtureMatchImportsSaga(action): any {
  yield put(
    sagaActions.getAllFixtureMatchImportsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.fixtureMatchImports.pagination),
    )
    : action.payload.pagination;

  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).fixtureMatchImports.list(action.payload.organisationId, paginationObject);

  if (response) {
    const normalizedResponse = normalize(
      response,
      fixtureMatchImportListSchema,
    );

    yield put(
      sagaActions.getAllFixtureMatchImportsSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllFixtureMatchImportsFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createFixtureMatchImportSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_FIXTURE_MATCH_IMPORT_REQUESTED,
    createFixtureMatchImportSaga,
  );
}

function* updateFixtureMatchImportSagaWatcher(): any {
  yield takeLatest(
    types.UPDATE_FIXTURE_MATCH_IMPORT_REQUESTED,
    updateFixtureMatchImportSaga,
  );
}

function* getFixtureMatchImportSagaWatcher(): any {
  yield takeLatest(
    types.GET_FIXTURE_MATCH_IMPORT_REQUESTED,
    getFixtureMatchImportSaga,
  );
}

function* getAllFixtureMatchImportsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_FIXTURE_MATCH_IMPORTS_REQUESTED,
    getAllFixtureMatchImportsSaga,
  );
}

export default function* root(): any {
  yield all([
    createFixtureMatchImportSagaWatcher(),
    updateFixtureMatchImportSagaWatcher(),
    getFixtureMatchImportSagaWatcher(),
    getAllFixtureMatchImportsSagaWatcher(),
  ]);
}
